import React from "react";
import Modal, {
  ModalPrimaryButton,
  ModalSecondaryButton,
} from "../common/Modal";

function ResetLearnerPasswordModal({ isOpen, student, user, onClose, onConfirm, isLoading }) {
  const targetUser = user || student;
  if (!isOpen || !targetUser) return null;

  const userName = targetUser.firstName && targetUser.lastName
    ? `${targetUser.firstName} ${targetUser.lastName}`
    : targetUser.username || "this user";

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Reset user password"
      subtitle="Internal staff action"
      icon="fa-key"
      size="lg"
      closeOnBackdrop={!isLoading}
      closeOnEscape={!isLoading}
      footer={
        <>
          <ModalSecondaryButton onClick={onClose} disabled={isLoading}>
            Cancel
          </ModalSecondaryButton>
          <ModalPrimaryButton
            onClick={onConfirm}
            loading={isLoading}
            loadingText="Resetting..."
          >
            Confirm reset
          </ModalPrimaryButton>
        </>
      }
    >
      <div className="space-y-4">
        <p className="text-sm text-slate-cloud">
          Do you want to reset the password for{" "}
          <span className="font-semibold text-grey-dusk">{userName}</span>?
        </p>

        <div className="rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-900">
          <p className="font-semibold">Standard onboarding password</p>
          <p className="mt-2 break-all font-mono text-base">Welcome2Journey!</p>
          <p className="mt-2 text-amber-800">
            The user will be required to change it after the next login.
          </p>
        </div>
      </div>
    </Modal>
  );
}

export default ResetLearnerPasswordModal;
